module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/48b48339a84fc360f393a5b79f355e67.png";